export default __webpack_public_path__ + "static/media/fontRoboto400_greek-ext.16961982.woff2";